import {DeviceAdminDto} from '../dtos/deviceAdminDto';
import {AccountAdminDto} from '../dtos/accountAdmin.dto';

export class DeviceAccountInformationExportModel {
    deviceCode: string;
    userCode: string;
    userAgent: string;
    appVersion: string;
    notificationsId: string;
    accountEmail: string;
    accountCountry: string;

    constructor() {}

    public static from(devices: DeviceAdminDto[], accounts: AccountAdminDto[]): DeviceAccountInformationExportModel[] {
        const data = [];
        devices.forEach((device, i) => {
            if (device.notificationsId !== null && device.notificationsId !== undefined && device.notificationsId !== '') {
                const convertedData = new DeviceAccountInformationExportModel();
                convertedData.deviceCode = device.code;
                convertedData.userCode = device.userCode;
                convertedData.notificationsId = device.notificationsId;
                convertedData.userAgent = device.userAgent;
                convertedData.appVersion = device.appVersion;

                const relatedAccount = accounts.find(account => account.code === device.userCode);
                if (relatedAccount !== undefined) {
                    convertedData.accountEmail = relatedAccount.email;
                    convertedData.accountCountry = relatedAccount.country;
                }

                data.push(convertedData);
            }
        });

        return data;
    }
}
